export default __webpack_public_path__ + "static/media/p2.64d208dc.png";